import * as React from 'react';
import { namespacedClassnames } from '../../../common/namespace-classes';
export var Loader = function (props) {
    var classNames = namespacedClassnames('loader', { centered: props.isCentered });
    return (React.createElement("div", { className: classNames },
        React.createElement("div", { className: 'loader-inner' }),
        React.createElement("div", { className: 'loader-inner delayed' })));
};
//# sourceMappingURL=loader.js.map